import { render, staticRenderFns } from "./SingleDiffElement.vue?vue&type=template&id=f5ba16f4&scoped=true&"
import script from "./SingleDiffElement.vue?vue&type=script&lang=ts&"
export * from "./SingleDiffElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ba16f4",
  null
  
)

export default component.exports